import Tooltip from "../../utils/Tooltip";
import isTouchDevice from "../SE-Component/Tooltip";

const AnchorResource = ({
  id,
  name = "mode",
  value,
  label,
  checked,
  disabled,
  onChange,
  tooltipContent,
  useSeTooltip = true,
  customStyle = {},
  children
}) => {
  return (
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
        <div className="custom-control custom-radio">
          <input
            type="radio"
            id={id}
            name={name}
            className="custom-control-input islandableRadio asCompatible"
            value={value}
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            style={customStyle}
          />

          <label
            className="custom-control-label line-height-25"
            htmlFor={id}
            style={customStyle}
          >
            {label}
          </label>

          {useSeTooltip ? (
            <span className="se-block-enabled">
              <se-tooltip
                action={isTouchDevice() ? "click" : "hover"}
                position="right"
              >
                <se-icon
                  option="raised"
                  color="secondary"
                  slot="tooltip"
                  disabled={disabled}
                >
                  information_circle
                </se-icon>
                <se-tooltip-content>{tooltipContent}</se-tooltip-content>
              </se-tooltip>
            </span>
          ) : (
            <Tooltip
              position="right"
              iconColor="secondary"
              iconSize="small"
              information={tooltipContent}
              disabled={disabled}
            />
          )}
        </div>
      </div>
        {children}
    </div>
  );
};

export default AnchorResource;